// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2pHGF","requiredAsterisk":"Info_requiredAsterisk__2oWoO"};